import React from "react";
import "../App.css";

function TermsOfUsePage() {
  return (
    <div
      className="terms-page"
      style={{
        padding: "4rem 2rem",
        maxWidth: "1000px",
        margin: "0 auto",
        lineHeight: "1.8",
      }}
    >
      <h1 style={{ marginBottom: "2rem" }}>Nutzungsbedingungen</h1>
      <p>
        Diese Nutzungsbedingungen regeln die Nutzung der Onenizer-App und der
        dazugehörigen Website.
      </p>
    </div>
  );
}

export default TermsOfUsePage;
